import {
  BULK_OUTLET_DO_SHOW_LOG,
  BULK_OUTLET_LOG_CHANGE_PAGE,
  BULK_OUTLET_UPDATE_ABORT_PROCESS,
  BULK_OUTLET_UPDATE_CONFIRM_PROCESS_RESPOND,
  BULK_OUTLET_UPDATE_INITIALIZE_PROCESS_STATE,
  BULK_OUTLET_UPDATE_PREPEND_OUTLET_ERROR,
  BULK_OUTLET_UPDATE_SET_CURRENT_OUTLET_ID,
  BULK_OUTLET_UPDATE_SET_IS_PROCESSING,
  BULK_OUTLET_UPDATE_SET_PROCESS_STATUS,
  BULK_OUTLET_UPDATE_SET_PROCESSED_COUNT,
  BULK_OUTLET_UPDATE_SHOW_CONFIRM_PROCESS_MODAL,
  DO_BULK_OUTLET_UPDATE,
  BULK_OUTLET_LOG_SET_SHOWN,
  BULK_OUTLET_LOG_SET_DATA,
  BULK_OUTLET_LOG_SET_IS_LOADING,
  BULK_OUTLET_LOG_SET_ERRORS,
  BULK_OUTLET_SET_GLOBAL_ERROR,
} from 'state/actionTypes';

export const setIsProcessing = isProcessing => ({
  type: BULK_OUTLET_UPDATE_SET_IS_PROCESSING,
  payload: { isProcessing },
});

export const initializeProcessState = (expirationDate, outletIds) => ({
  type: BULK_OUTLET_UPDATE_INITIALIZE_PROCESS_STATE,
  payload: { expirationDate, outletIds },
});

export const setProcessedCount = processed => ({
  type: BULK_OUTLET_UPDATE_SET_PROCESSED_COUNT,
  payload: { processed },
});

export const doBulkOutletUpdate = (outletIds, expirationDate) => ({
  type: DO_BULK_OUTLET_UPDATE,
  payload: { outletIds, expirationDate },
});

export const prependOutletError = (outletId, messages) => ({
  type: BULK_OUTLET_UPDATE_PREPEND_OUTLET_ERROR,
  payload: { outletId, messages },
});

export const setProcessStatus = status => ({
  type: BULK_OUTLET_UPDATE_SET_PROCESS_STATUS,
  payload: { status },
});

export const setCurrentOutletId = outletId => ({
  type: BULK_OUTLET_UPDATE_SET_CURRENT_OUTLET_ID,
  payload: { outletId },
});

export const abortProcess = () => ({
  type: BULK_OUTLET_UPDATE_ABORT_PROCESS,
});

export const showConfirmProcessModal = () => ({
  type: BULK_OUTLET_UPDATE_SHOW_CONFIRM_PROCESS_MODAL,
});

export const confirmProcess = proceed => ({
  type: BULK_OUTLET_UPDATE_CONFIRM_PROCESS_RESPOND,
  payload: { proceed },
});

export const setLogModalShown = shown => ({
  type: BULK_OUTLET_LOG_SET_SHOWN,
  payload: { shown },
});

export const doShowLogs = () => ({
  type: BULK_OUTLET_DO_SHOW_LOG,
});

export const setLogPage = page => ({
  type: BULK_OUTLET_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setLogData = (data, paging) => ({
  type: BULK_OUTLET_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetLogData = () =>
  setLogData([], { page: 1, size: 20, total: 0 });

export const setLogIsLoading = isLoading => ({
  type: BULK_OUTLET_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setLogErrors = errors => ({
  type: BULK_OUTLET_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearLogErrors = () => setLogErrors([]);

export const setGlobalError = error => ({
  type: BULK_OUTLET_SET_GLOBAL_ERROR,
  payload: { error },
});
